import { Injectable, inject, signal } from '@angular/core';
import {SliderManagementModel} from "../models/slider-management.model";
import {BlobService} from "../../../core/base/blob.service";
import {ResponseModel} from "../../../core/base/response.model";

@Injectable({
  providedIn: 'root',
})
export class SliderManagementService {
  private container = 'marketing';

  private _slider = signal<SliderManagementModel[]>([]);
  readonly slider = this._slider.asReadonly();

  private _isLoading = signal(false);
  readonly isLoading = this._isLoading.asReadonly();

  private blobService = inject(BlobService);

  async downloadList(edit?: boolean) {
    this._isLoading.set(true);
    try {
      const data = await this.blobService.getData('slider/slider.json', this.container, edit);
      const parsed = JSON.parse(<string>data) as SliderManagementModel[];
      this._slider.set(parsed);
      return parsed;
    } catch (error) {
      console.error('Error loading slides:', error);
      this._slider.set([]);
      return []
    } finally {
      this._isLoading.set(false);
    }
  }

  async addSlide(value: SliderManagementModel) {
    const current = this._slider();
    value.slideId = Date.now();
    const updated = [...current, value];
    this._slider.set(updated);

    const response = await this.blobService.setData(
      'slider/slider.json',
      JSON.stringify(updated),
      this.container
    );
    return new ResponseModel({ error_code: response.error_code, response_body: value });
  }

  async updateSlide(value: SliderManagementModel) {
    const current = this._slider();
    const idx = current.findIndex((slide: { slideId: any; }) => slide.slideId === value.slideId);
    if (idx !== -1) {
      const updated = [...current];
      updated[idx] = value;
      this._slider.set(updated);

      const response = await this.blobService.setData(
        'slider/slider.json',
        JSON.stringify(updated),
        this.container
      );
      return new ResponseModel({ error_code: response.error_code, response_body: value });
    }
    return new ResponseModel({ error_code: 'NOT_FOUND', response_body: value });
  }

  async deleteSlide(slide: SliderManagementModel) {
    const current = this._slider();
    const updated = current.filter(n => n.slideId !== slide.slideId);
    this._slider.set(updated);

    const response = await this.blobService.setData(
      'slider/slider.json',
      JSON.stringify(updated),
      this.container
    );
    return new ResponseModel({ error_code: response.error_code, response_body: slide });
  }

  async uploadImage(file: any, name: string) {
    return this.blobService.uploadFile(file, name, this.container);
  }
}
